import PropTypes from 'prop-types';
import CounterComponent from '../../../components/counter/CounterComponent';
import ImageAsync from '../../../components/native/ImageAsync';

const FoodCardCounterItem = ({ name, action = () => { }, img, link = '' }) => {
    return (
        <div className="w-full rounded border flex justify-between items-center p-2 mb-4 mt-4">
            <div className='flex flex-start'>
                <ImageAsync className="rounded-md" src={"/assets/img/svg/" + img} alt={name} width={'94px'} height={'94px'} />
                <span className="ml-4" style={{ fontSize: '16px' }}>{name}</span>
            </div>

            <span>
                <div className='flex items-end h-24'>
                    <CounterComponent />
                </div>
            </span>
        </div>
    );
};

FoodCardCounterItem.propTypes = {
    name: PropTypes.string,
    action: PropTypes.func,
    img: PropTypes.string,
    link: PropTypes.string
};

export default FoodCardCounterItem;
